import React,{ useEffect} from 'react'
import SarasHotKeys from '../../notifications/SarasHotKeys';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Icon from '@material-ui/core/Icon';
import SearchIcon from '@material-ui/icons/Search';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '0px 0px',
    display: 'flex',
    alignItems: 'center',
    height:'30px',
    boxSizing: 'border-box',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    border: 'none',
    padding: 10
  },
  iconButton: {
    padding: 0,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const SarasSearchInput = (props) => {
    const { onChange, onSearchAsKeyed, ksc, tooltipAlign, value,
        actionButton, className, elevation,
        inputRef, autofocus, tooltip, placeholder, stayFocused, ...restProps } = props;
    const [txtVal, setTxtVal] = React.useState(value);
      const classes = useStyles();
    const inputRefInternal = React.useRef();

    const initializeTxtValue = () => {
        setTxtVal(value);
    }

    useEffect(initializeTxtValue,[value]);

    useEffect(()=>{
        // console.log("stayfocused", stayFocused);
        if(autofocus && (inputRef || inputRefInternal).current)
        {
            (inputRef || inputRefInternal).current.focus();
        }
    },[inputRef, inputRefInternal, autofocus, stayFocused]);

    const onInputBlur = (e) => {
        if(txtVal !== value)
            if(onChange)onChange(e, e.currentTarget.value);
    }

    const onFocus = (e) => {
        if((inputRef || inputRefInternal).current)
        {
            (inputRef || inputRefInternal).current.select();
        }
    }

    const onHotkeyPress = (e) => {
        if((inputRef || inputRefInternal).current){
            e.preventDefault();
            (inputRef || inputRefInternal).current.focus();
        }
    }

    const onInputChange = (e) => {
        setTxtVal(e.currentTarget.value);
        if(onSearchAsKeyed) onSearchAsKeyed(e, e.currentTarget.value);
    }

    return (
        <SarasHotKeys ksc={ksc} tooltipAlign={tooltipAlign} onHotKey={onHotkeyPress} tooltip={tooltip}>
            <Paper component="form" className={`${classes.root} ${className || ''}`}
            elevation={elevation}>
            {/* <Paper component="form" className={classes.root}> */}
                <Icon aria-label="search" className={classes.iconButton}>
                    <SearchIcon className={'uiAppSearchIcon'}/>
                </Icon>
                <input ref={inputRef || inputRefInternal} type="search" className="uiSearchText" {...restProps} placeholder={placeholder} onBlur={onInputBlur} onFocusCapture={onFocus} onChange={onInputChange} value={txtVal} />
                {actionButton}
            </Paper>
        </SarasHotKeys>
    )
}

export default SarasSearchInput